import api from './index'

const axios = require('axios')

export default {
    getAll: (filterSerialNumber) => {

        if(filterSerialNumber!=''){
            const path = '/machines/all/'+filterSerialNumber
            return api.handling(axios.get(path))
        }
        else{
            const path = '/machines/all'

            return api.handling(axios.get(path))
        }

    },

    getInfo: (id) => {
        const path = `/machines/${id}/info`

        return api.handling(axios.get(path))
    },

    updateInfo: (id, data) => {
        const path = `/machines/${id}/info`

        return api.handling(axios.put(path, data))
    },

    getDeals: (id) => {
        const path = `/machines/${id}/deals`

        return api.handling(axios.get(path))
    },

    updateDeals: (id, data) => {
        const path = `/machines/${id}/deals`

        return api.handling(axios.put(path, data))
    },

    getPaymentMethods: (id) => {
        const path = `/machines/${id}/payment-methods`

        return api.handling(axios.get(path))
    },

    updatePaymentMethods: (id, data) => {
        const path = `/machines/${id}/payment-methods`

        return api.handling(axios.put(path, data))
    },

    getSaleRecords: (id, from, to, items, page, machine_type) => {
        const path = `/machines/${id}/sale-records`

        return api.handling(axios.get(path, {
            params: {
                from: from,
                to: to,
                items: items,
                page: page,
                machine_type: machine_type
            }
        }))
    },

    getSerialNumbers: () => {
        const path = '/machines/all/serial-numbers'

        return api.handling(axios.get(path))
    },

    getSerialNumbersByType: (type) => {
        const path = '/machines/all/serial-numbers-type/'+type

        return api.handling(axios.get(path))
    },

    // 歸為 machine or settlements？
    getSettlements: (id, items, page) => {
        const path = `/settlements/${id}/all`

        return api.handling(axios.get(path, {
            params: {
                items: items,
                page: page
            }
        }))
    },

    // 系統設定（？）
    getOptions: () => {
        const path = '/machines/options'

        return api.handling(axios.get(path))
    },

    create: (data) => {
        const path = '/machines/create'

        return api.handling(axios.post(path, data))
    },

    exportSaleRecords: (id, from, to) => {
        const path = `/machines/${id}/export-sale-records`

        return api.handling(axios.get(path, {
            responseType: 'blob',
            params: {
                from: from,
                to: to
            }
        }))
    },
}
